/* eslint-disable no-restricted-imports */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import {
	BoldTextAttrSx,
	tileDescriptionSX,
	noMargin,
} from '@/components/content/ProductDetails/styles/attributes';
import { useIsOpen } from 'integration/hooks/useIsOpen';
import { AdaptiveDialog } from '@/components/blocks/AdaptiveDialog';
import { GuiaTallasDrawer } from '@/components/blocks/ProductDetails/GuiaTallasDrawer';

export const BundleAttributes: FC = () => {
	const openDrawerSizeGuide = useIsOpen();

	return (
		<>
			<Typography>
				<Typography sx={BoldTextAttrSx}>{'Las tallas son MX'}</Typography>
				<Typography sx={tileDescriptionSX}>
					{'(cm), consulta la'}
					<Linkable href="" type="inline" sx={noMargin} onClick={openDrawerSizeGuide.on}>
						{'Guía de tallas'}
					</Linkable>
					{' y compara tallas nacionales'}
				</Typography>
			</Typography>
			<AdaptiveDialog
				open={openDrawerSizeGuide.open}
				onClose={openDrawerSizeGuide.off}
				title="GUIA DE TALLAS"
			>
				<GuiaTallasDrawer />
			</AdaptiveDialog>
		</>
	);
};
